export default "__VITE_ASSET__FBKs$SRP__"